import React, { Component } from 'react';
import { Link } from "react-router-dom";

import './styles.css';

class RaisedButton extends Component {
  render(){
    if(this.props.linksTo){
      return (
        <Link to={this.props.linksTo}>
          <div className="Raised-Button">{this.props.text || 'Button Text Sample'}</div>
        </Link>
      )
    }
    let classNames = ['Raised-Button'];
    if(this.props.disable){
      classNames.push('disabled')
    }
    return (
      <div onClick={this.props.onClick} className={`${classNames.join(' ')} ${this.props.className || ''}`}>{this.props.text || 'Button Text Sample'}</div>
    );
  }
}

export default RaisedButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/RaisedButton/RaisedButton.js